import { ClearVerifyStaffRoleLabels } from '@clearverify/constants';

import { ClearVerifyStaffRole } from 'src/api';

/** The roles a Super Admin picks from, with the copy shown beside each. */
export const CLEAR_VERIFY_STAFF_ROLE_OPTIONS = [
  {
    value: ClearVerifyStaffRole.Manager,
    title: ClearVerifyStaffRoleLabels[ClearVerifyStaffRole.Manager],
    description:
      'Works with employers, verifiers, employees, PEOs, partnerships, reports, and the email tracker.',
  },
  {
    value: ClearVerifyStaffRole.Admin,
    title: ClearVerifyStaffRoleLabels[ClearVerifyStaffRole.Admin],
    description:
      'Everything a Manager has, plus the dashboard, inbox, billing rules, and API & integrations.',
  },
  {
    value: ClearVerifyStaffRole.SuperAdmin,
    title: ClearVerifyStaffRoleLabels[ClearVerifyStaffRole.SuperAdmin],
    description:
      'Everything an Admin has, plus inviting Clear Verify staff, changing their role, and granting them Financial reports and the monthly financial report. Their own role and access stay as they are.',
  },
] as const;
